import { toast } from 'react-toastify';
import { ErrorMessageDataType } from 'shared/types';
import { partApi } from 'features/getParticipants/api/model/usersApi';

const uploadFileApi = partApi.injectEndpoints({
  endpoints: (builder) => ({
    uploadShopDotsExcel: builder.mutation({
      query: (params) => {
        const formData = new FormData();
        formData.append('file', params.file);
        return {
          url: `/promo-b2b/admin/promo-b2b/admin/activities/${params.id}/import/participants/`,
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: (result, error) => {
        const error_message = error?.data as ErrorMessageDataType;
        if (error) {
          toast.error(error_message.detail, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Файл успешно принят в обработку. Вы можете проверить его статус в Загрузках.', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return ['PartPromo'];
      },
    }),
  }),
});

export const { useUploadShopDotsExcelMutation } = uploadFileApi;
